<template>
    <div>
        <button @click="isModalOpen = true">
            <slot
                name="handle"
            />
        </button>
        <div
            v-if="isModalOpen"
            class="
                bg-black
                bg-opacity-80
                fixed
                flex
                inset-0
                items-center
                justify-center
                z-100
            "
        >
            <div
                @click="isModalOpen = false"
                class="absolute inset-0"
            />
            <div class="w-full max-w-7xl p-4 lg:p-8">
                <div class="aspect-w-16 aspect-h-9">
                    <video
                        playsinline
                        autoplay
                        loop
                        controls
                        class="absolute top-0 w-full h-full object-cover"
                    >
                        <source :src="src" />
                    </video>

                    <button
                        @click="isModalOpen = false"
                        class="
                            -top-10
                            absolute
                            bottom-auto
                            flex
                            h-8
                            items-center
                            justify-center
                            left-auto
                            lg:-right-8
                            right-0
                            text-4xl
                            text-white
                            w-8
                        "
                    >
                        <icon name="close" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoModal',
    props: {
        src: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            isModalOpen: false,
        };
    },
};
</script>
